import { plainToClass } from "class-transformer";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { RemoveElementFromArray } from "../../../../shared/scripts/array-functions";
import { RenderNullableNumber, RenderProgressBar } from "../../../../shared/scripts/table-functions";
import { FinancialEntry, FinancialGraphData, OverviewDataElement, VoucherEntry } from "./financials.entities"
import { FinancialCharts } from './financials.chart';
import { InvoicesTable } from './financials.table';
import { VouchersTable } from './voucher.table';
import { EstimatedSpendTable } from './financials.spend';
import { FinancialVendorCharts } from './financials-vendors.chart';
import { ResetDateFilters, ResetDropdownFilters } from "../../../../shared/scripts/filtering/filtering.utilities";
import { FinancialSpendEntry, HistoricalFinancialSpendEntry, CumulativeInvoiceEntry } from "./financials.spend.entities";
import { forEach } from "lodash";
import { FinancialForecastEntry } from "./financials.forecast.entities";
import { ForecastSection } from "./financials.forecast";

export class FinancialsPage {

    invoiceTable: any;
    estimatedSpendTable: any;
    forecastSection: any;
    financialCharts: FinancialCharts;
    financialGraphData: FinancialGraphData[];
    financialTableData: FinancialEntry[];
    financialVendorGraphData: FinancialGraphData[];
    overviewData: OverviewDataElement[];
    estimatedSpendData: FinancialSpendEntry[];
    forecastSpendPEData: FinancialForecastEntry[];
    forecastSpendTEData: FinancialForecastEntry[];
    historicalSpendData: HistoricalFinancialSpendEntry[];
    cumulativeInvoicedData: CumulativeInvoiceEntry[];

    constructor(DataJson: any, GraphDataJson: any, VendorGraphDataJson: any, OverviewDataJson: any, SpendDataJson: any, lastUpdatedJson: any, forecastPEJson: any, forecastTEJson: any, HistoricalSpendDataJson: any, CumulativeInvoicedJson: any) {

        $(() => {
            this.financialTableData = plainToClass(FinancialEntry, <FinancialEntry[]>DataJson);
            this.financialGraphData = plainToClass(FinancialGraphData, <FinancialGraphData[]>GraphDataJson);
            this.financialVendorGraphData = plainToClass(FinancialGraphData, <FinancialGraphData[]>VendorGraphDataJson);
            this.overviewData = plainToClass(OverviewDataElement, <OverviewDataElement[]>OverviewDataJson);
            this.estimatedSpendData = plainToClass(FinancialSpendEntry, <FinancialSpendEntry[]>SpendDataJson);
            this.forecastSpendPEData = plainToClass(FinancialForecastEntry, <FinancialForecastEntry[]>forecastPEJson);
            this.forecastSpendTEData = plainToClass(FinancialForecastEntry, <FinancialForecastEntry[]>forecastTEJson);
            this.historicalSpendData = plainToClass(HistoricalFinancialSpendEntry, <HistoricalFinancialSpendEntry[]>HistoricalSpendDataJson);
            this.cumulativeInvoicedData = plainToClass(CumulativeInvoiceEntry, <CumulativeInvoiceEntry[]>CumulativeInvoicedJson);

            // Pull Additional JsonListing for FinancialGraphData
            this.initializeCharts();
            this.initializeTable();
            this.initializeOverviewData();
            this.initializeSpend();
            this.initializeForecasts();

            this.hideLoading();
            new DateUpdatedSection(lastUpdatedJson, false, true, false, true);
        });
    }

    initializeSpend(): void {
        this.estimatedSpendTable = new EstimatedSpendTable(this.estimatedSpendData);
    }

    initializeForecasts(): void {
        this.forecastSection = new ForecastSection(this.forecastSpendPEData, this.forecastSpendTEData, this.historicalSpendData, this.cumulativeInvoicedData);
    }

    initializeCharts(): void {
        let sortArray = ["Infrastructure", "VITAL", "NEURO", "AUTONOMIC", "SLEEP", "ENERGIZE", "Committee Members", "Other CT ACC Subcontracts"];
        this.financialGraphData.forEach(entry => entry.initialize());
        this.financialGraphData = this.financialGraphData.sort((a, b) => sortArray.indexOf(a.Name) - sortArray.indexOf(b.Name));
        let financialCharts = new FinancialCharts();
        financialCharts.setGraphContent(this.financialGraphData);

        this.financialVendorGraphData.forEach(entry => entry.initialize());
        let vendorCharts = new FinancialVendorCharts();
        vendorCharts.setGraphContent(this.financialVendorGraphData);
    }

    initializeTable(): void {
        //let sortArray = ["Infrastructure", "VITAL", "NEURO", "AUTONOMIC", "SLEEP", "ENERGIZE", "Committee Members", "Other CT ACC Subcontracts"];
        //console.log(this.financialTableData);
        //this.financialTableData = this.financialTableData.sort((a, b) => sortArray.indexOf(a.StudyName) - sortArray.indexOf(b.StudyName));

        this.invoiceTable = new InvoicesTable(this.financialTableData);
    }

    initializeOverviewData(): void {
        let totals = new OverviewDataElement();
        totals.StudyId = 9;

        let totalInvoiced = [0,0];
        let totalEnrolled = [0,0];
        let totalEstimated = [0,0];

        forEach(this.overviewData, (entry) => {
            totalInvoiced[0] = totalInvoiced[0] + entry.Invoiced[0];
            totalInvoiced[1] = totalInvoiced[1] + entry.Invoiced[1];
            entry.initialize();
            
            totalEstimated[0] = totalEstimated[0] + entry.EstimatedSpend[0];
            totalEstimated[1] = totalEstimated[1] + entry.EstimatedSpend[1];
            totalEnrolled[0] = totalEnrolled[0] + entry.Enrollment[0];
            totalEnrolled[1] = totalEnrolled[1] + entry.Enrollment[1];
        });

        totals.Enrollment = totalEnrolled;
        totals.EstimatedSpend = totalEstimated;
        totals.Invoiced = totalInvoiced;
        totals.Timeline = [-1,-1];

        totals.initialize();
        totals.Study = `Total<sup> 3</sup>`;

        this.overviewData.sort((a, b) => {
            if (a.SortOrder == b.SortOrder) return a.Study.localeCompare(b.Study);
            else return a.SortOrder - b.SortOrder;
        });  
        this.overviewData.push(totals);


        let dataTable: any = $('#financials-overview-table').DataTable({
            "dom": '<"top-controls"B0>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: false,
            scrollCollapse: true,
            orderCellsTop: true,
            ordering: false,
            columns: [
                { data: "Study", className: "text-left font-size12 font-bold", width: "6%" },
                { data: "InvoicedCountDisplay", className: "text-right font-size12 nowrap", width: "5%" },
                { data: "InvoicedPercent", className: "text-left font-size12 nowrap", width: "18%", render: RenderProgressBar },
                { data: "EstimatedSpendCountDisplay", className: "text-right font-size12 nowrap", width: "5%" },
                { data: "EstimatedSpendPercent", className: "text-left font-size12 nowrap", width: "18%", render: RenderProgressBar },
                { data: "EnrollmentCountDisplay", className: "text-right font-size12 nowrap", width: "5%" },
                { data: "EnrollmentPercent", className: "text-left font-size12 nowrap", width: "18%", render: RenderProgressBar },
                { data: "TimelineCountDisplay", className: "text-right font-size12 nowrap", width: "5%" },
                { data: "TimelinePercent", className: "text-left font-size12 nowrap", width: "18%", render: RenderProgressBar },
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            //order: [[5, 'asc']],
            data: this.overviewData,
        });

    }

    hideLoading() {
        $("#loading-indicator").hide();
        $("#financial-tab-content").removeClass("invisible");
        $("#date-updated-section").removeClass("invisible");
        $("#navigation-tabs").removeClass("invisible");
    }

    initializeLastUpdated(lastUpdated: string) {
        $("#last-update-date").text(lastUpdated);
    }

    resetInvoiceFilters(): void {
     
        ResetDropdownFilters(['#study-dropdown', '#invoice-status-dropdown', '#vendor-dropdown', '#entry-type-dropdown']);
        ResetDateFilters(['#added-since-date', '#added-before-date']);

        this.invoiceTable.clearSearchBar();
    }

    toggleSummary(): void {
        $("#financial-summary-by-study").toggleClass("d-none");
        $("#financial-summary-by-vendor").toggleClass("d-none");
        $(".switch-label").toggleClass("font-weight-bold");

        //to make sure the dropdowns go "down"
        ['#subcontract-table-column-filter-dropdown', '#subcontract-vendor-table-column-filter-dropdown'].forEach((id: string) => $(id).selectpicker("refresh"));
    }

    resetSpendFilters(): void {
        this.estimatedSpendTable.resetFilters();
    }

    resetForecastFilters(): void {
        this.forecastSection.resetFilters();
    }

    updateForecastTable(value: string): void {
        this.forecastSection.updateForecastTable(value);
    }
}